import { X } from "@phosphor-icons/react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

/** Removes one set from the invoice after a confirm step; totals recompute server-side. */
export const RemoveSetButton = ({ setNumber, name, onRemove }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button className="no-print inline-flex items-center gap-1 font-mono text-[10px] text-gray-400 hover:text-[#E3000B]" title="Remove this set from the invoice" data-testid={`item-remove-${setNumber}`}>
        <X size={10} weight="bold" /> remove
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-white border-[#E4E4E0]" data-testid="item-remove-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-head">Remove #{String(setNumber).replace(/-1$/, "")} from this invoice?</AlertDialogTitle>
        <AlertDialogDescription className="font-mono text-xs text-gray-600">{name} comes off the deal and the total recalculates. The customer's invoice link updates instantly.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="font-mono text-xs" data-testid="item-remove-cancel">Keep it</AlertDialogCancel>
        <AlertDialogAction onClick={() => onRemove(setNumber)} className="bg-[#E3000B] text-white font-mono text-xs hover:bg-[#B8000A]" data-testid="item-remove-confirm">Remove set</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
